export class CrfDemographicRequest{
    "studyId":Number;
    "userId":Number;
    "visitId":Number;
    "patientId":String;
    "sectionId":Number;
}